import { useGetDriverAlertsQuery } from "../store/api/driversApi";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  LayoutDashboard,
  Car,
  Users,
  Package,
  ShoppingCart,
  // Tag,
  MapPin,
  Construction,
  BookOpen,
  // Clock,
  Settings,
  LogOut,
} from "lucide-react";
import logo from "../assets/images/logo.png";
import { clearCredentials } from "../store/authSlice";

const navItems = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/" },
  { label: "Drivers", icon: Car, path: "/drivers" },
  { label: "Users", icon: Users, path: "/users" },
  { label: "Services", icon: Package, path: "/services" },
  { label: "Orders", icon: ShoppingCart, path: "/orders" },
  // { label: "Time Slots", icon: Clock, path: "/time-slots" },
  // { label: "Coupons", icon: Tag, path: "/coupons" },
  { label: "Spots", icon: MapPin, path: "/spots" },
  { label: "Road Blocks", icon: Construction, path: "/road-blocks" },
  { label: "Blogs", icon: BookOpen, path: "/blogs" },
];

export default function Sidebar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: driverAlerts } = useGetDriverAlertsQuery(undefined, { pollingInterval: 5000, refetchOnFocus: true });
  const openDriverAlerts = driverAlerts?.data?.length ?? 0;

  const handleLogout = () => {
    dispatch(clearCredentials());
    navigate("/login");
  };

  return (
    <aside className="w-[175px] min-h-screen bg-white flex flex-col py-6 px-4 border-r border-gray-100 fixed top-0 left-0">
      {/* Logo */}
      <div className="flex items-center gap-2 mb-2 px-2">
        <img
          src={logo}
          alt="Contentour Bonaire Logo"
          className="object-contain"
        />
      </div>

      {/* Nav */}
      <nav className="flex flex-col gap-1 flex-1">
        {navItems.map(({ label, icon: Icon, path }) => (
          <NavLink
            key={label}
            to={path}
            end={path === "/"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-[10px] rounded-lg text-[13px] transition-all ${
                isActive
                  ? "font-manrope-bold text-gray-900 bg-gray-50 border-l-[3px] border-gray-900 rounded-l-none"
                  : "font-manrope-regular text-gray-500 hover:text-gray-800 hover:bg-gray-50"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={16} strokeWidth={isActive ? 2.2 : 1.6} />
                <span>{label}</span>
                {path === "/drivers" && openDriverAlerts > 0 && (
                  <span aria-label={`${openDriverAlerts} open vehicle alerts`} className="ml-auto bg-red-600 text-white rounded-full px-1.5 text-[11px]">{openDriverAlerts}</span>
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Bottom */}
      <div className="flex flex-col gap-1 mt-4">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-[10px] rounded-lg text-[13px] transition-all ${
              isActive
                ? "font-manrope-bold text-gray-900 bg-gray-50"
                : "font-manrope-regular text-gray-500 hover:text-gray-800 hover:bg-gray-50"
            }`
          }
        >
          <Settings size={16} strokeWidth={1.6} />
          <span>Settings</span>
        </NavLink>

        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-3 py-[10px] rounded-lg text-[13px] font-manrope-regular text-red-500 hover:bg-red-50 transition-all w-full text-left"
        >
          <LogOut size={16} strokeWidth={1.6} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
